exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Forms{position:relative}@media screen and (max-width:767px){.Forms{height:100%}}.Forms__loading{position:absolute;top:50%;left:50%;right:auto;bottom:auto;margin-right:-50%;transform:translate(-50%,-50%);font-size:16px}.Forms__frame{width:760px;height:calc(100vh - 150px)}@media screen and (max-width:767px){.Forms__frame{width:100%;height:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../src/components/forms/index.scss
// module id = 665
// module chunks = 0